import React from 'react';
import { BasicValuePropContainer } from '@/components';
import {
  TypeBasicValuePropContainer,
  type TypeBasicValuePropContainerFields,
  TypeMediaTextTitle,
  type TypeMediaTextTitleFields,
} from '@/core/generated-types';
import { Image } from '@/components/ui/Image';
import type { Entry } from 'contentful';
import { shouldHideWithLocaleOverride } from '@/utils/localeOverride';

interface ProductValuePropsInterface {
  productValueProps?: Entry<
    TypeBasicValuePropContainerFields | TypeMediaTextTitleFields
  >[];
  shouldUsePlayKitStyles?: boolean;
}

function ProductValueProps({
  productValueProps,
  shouldUsePlayKitStyles,
}: ProductValuePropsInterface) {
  if (!productValueProps) {
    return null;
  }

  const [maybeBasicValuePropContainer] = productValueProps;

  if (
    maybeBasicValuePropContainer?.sys?.contentType?.sys?.id ===
    'basicValuePropContainer'
  ) {
    const basicValuePropContainer =
      maybeBasicValuePropContainer as TypeBasicValuePropContainer;

    return <BasicValuePropContainer {...basicValuePropContainer.fields} />;
  }

  const defaultValueProps = (productValueProps as TypeMediaTextTitle[]).filter(
    (item) => !shouldHideWithLocaleOverride(item.fields?.localeOverride),
  );

  if (shouldUsePlayKitStyles) {
    return (
      <ul
        className="mx-4 flex flex-col gap-2 list-disc"
        data-testid="playkit-value-props"
      >
        {defaultValueProps.map((item) => {
          const {
            sys: { id },
            fields: { textHeading },
          } = item;

          return (
            <li key={id} className="list-item">
              <p className="w-auto">{textHeading}</p>
            </li>
          );
        })}
      </ul>
    );
  }

  return (
    <ul className="mt-4" data-testid="value-props">
      {defaultValueProps?.map((item) => {
        const {
          sys: { id },
          fields: { textHeading, image },
        } = item;

        return (
          <li key={id} className="flex-start flex flex-row items-center gap-2">
            {image && (
              <Image
                imageData={image}
                height={16}
                width={16}
                alt={image.fields.altText}
              />
            )}
            <p className="w-auto">{textHeading}</p>
          </li>
        );
      })}
    </ul>
  );
}

export default ProductValueProps;
